module.exports = __webpack_public_path__ + "img/10-half-lg.b46534c2.jpg";